module.exports = __webpack_public_path__ + "static/media/component-5.36de2d3e.svg";